export default __webpack_public_path__ + "static/media/gengarModel.fa37809b.glb";